import { render, staticRenderFns } from "./PaymentTerms.vue?vue&type=template&id=5f7c5f14&"
import script from "./PaymentTerms.vue?vue&type=script&lang=js&"
export * from "./PaymentTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports